import { ENABLE_POST_COMMENTS_SUCCESS } from '../../actions/enable-post-comments';
import { DISABLE_POST_COMMENTS_SUCCESS } from '../../actions/disable-post-comments';
import { categoryIds } from '../event-helpers';

const handler = ({ type, payload }) => ({
  evid: 231,
  is_commentable: type === ENABLE_POST_COMMENTS_SUCCESS ? 1 : 0,
  post_id: payload._id,
  category_ids: categoryIds(payload), // todo, [bug] categories are not set in state in members area posts and drafts page
});

export const uouToggleCommentsEvent = {
  [ENABLE_POST_COMMENTS_SUCCESS]: handler,
  [DISABLE_POST_COMMENTS_SUCCESS]: handler,
};
